"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(_ref) {
  var className = _ref.className;

  var prefixCls = "loader";
  var componentCls = (0, _classnames2.default)(prefixCls, className);

  return _react2.default.createElement(
    "div",
    { className: "loader-wrapper" },
    _react2.default.createElement("div", { className: componentCls })
  );
};

Loader.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string
} : {};

exports.default = Loader;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/loader/loader.js
// module id = 1414
// module chunks = 249